import type { TaskTemplateCategory } from "./types";

export const MSP_WEST_TENNESSEE_CONSULTING_TEMPLATES: TaskTemplateCategory = {
  id: "west-tennessee-consulting",
  name: "West Tennessee Consulting (WTC)",
  description: "Templates for West Tennessee Consulting general consulting work",
  templates: [
    {
      id: "client-consultation",
      name: "Client Consultation",
      description: "Initial consultation with new or existing WTC client",
      title: "Client Consultation: [Client Name]",
      description_text: `Conduct client consultation:

**Pre-Consultation:**
- [ ] Review client background and needs
- [ ] Prepare consultation agenda
- [ ] Gather relevant case studies or examples
- [ ] Set up meeting space or technology

**Consultation Agenda:**
- [ ] Welcome and introductions
- [ ] Understand client's current challenges
- [ ] Assess business needs and goals
- [ ] Discuss potential solutions
- [ ] Outline next steps and timeline

**Post-Consultation:**
- [ ] Send follow-up summary
- [ ] Prepare proposal if needed
- [ ] Schedule follow-up meeting
- [ ] Update CRM with consultation notes
- [ ] Begin project planning if applicable`,
      tags: ["wtc", "consulting", "client-meeting", "proposal"],
      priority: "high",
      status: "pending",
      category: "west-tennessee-consulting",
    },
    {
      id: "project-implementation",
      name: "Project Implementation",
      description: "Implement consulting project for WTC client",
      title: "Project Implementation: [Project Name]",
      description_text: `Implement consulting project:

**Project Kickoff:**
- [ ] Review project scope and objectives
- [ ] Establish project timeline and milestones
- [ ] Assign team members and responsibilities
- [ ] Set up project management tools
- [ ] Schedule regular check-ins

**Implementation Phase:**
- [ ] Execute project deliverables
- [ ] Monitor progress against timeline
- [ ] Communicate regularly with client
- [ ] Address any issues or changes
- [ ] Document all work completed

**Project Completion:**
- [ ] Finalize all deliverables
- [ ] Conduct project review with client
- [ ] Prepare final report and recommendations
- [ ] Schedule follow-up support if needed
- [ ] Update project documentation`,
      tags: ["wtc", "implementation", "project-management", "consulting"],
      priority: "high",
      status: "pending",
      category: "west-tennessee-consulting",
    },
    {
      id: "proposal-development",
      name: "Proposal Development",
      description: "Develop consulting proposal for WTC client",
      title: "Proposal Development: [Client Name]",
      description_text: `Develop comprehensive consulting proposal:

**Proposal Planning:**
- [ ] Review client needs and requirements
- [ ] Research client industry and challenges
- [ ] Develop solution approach
- [ ] Estimate project scope and timeline
- [ ] Prepare pricing structure

**Proposal Writing:**
- [ ] Write executive summary
- [ ] Detail proposed solution and approach
- [ ] Include project timeline and milestones
- [ ] Prepare pricing and terms
- [ ] Add relevant case studies and references

**Proposal Review:**
- [ ] Internal review and feedback
- [ ] Client-specific customization
- [ ] Final proofreading and formatting
- [ ] Prepare presentation materials
- [ ] Schedule client presentation

**Follow-up:**
- [ ] Present proposal to client
- [ ] Address questions and concerns
- [ ] Negotiate terms if needed
- [ ] Follow up on decision timeline
- [ ] Begin project if approved`,
      tags: ["wtc", "proposal", "consulting", "client-meeting"],
      priority: "medium",
      status: "pending",
      category: "west-tennessee-consulting",
    },
  ],
};
